import React__default from 'react';
import { FormContext } from './FormContext.es.js';
import { Body } from '../Typography/index.es.js';
import { SizeContext } from '../../contexts/SizeContext.es.js';
import { MAPPING_SIZE } from '../../constants/index.es.js';
import { mergeCls } from '../../helpers/utils.es.js';
import styled from '@emotion/styled';
import { Col } from '../Grid/Col.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const FormItemLabel = ({
  label,
  htmlFor,
  labelCol,
  labelAlign,
  colon,
  prefixCls,
  required,
  requiredMark
}) => {
  const size = React__default.useContext(SizeContext);
  if (!label)
    return null;
  return /* @__PURE__ */ React__default.createElement(FormContext.Consumer, {
    key: "label"
  }, ({
    vertical,
    labelAlign: contextLabelAlign,
    labelCol: contextLabelCol,
    colon: contextColon,
    requiredMark: contextRequiredMark
  }) => {
    var _a;
    const mergedLabelCol = labelCol || contextLabelCol || {};
    const mergedLabelAlign = labelAlign || contextLabelAlign;
    const labelClsBasic = `${prefixCls}-item-label`;
    const labelColClassName = mergeCls(labelClsBasic, mergedLabelAlign === "left" ? `${labelClsBasic}-left` : "", mergedLabelCol.className || "");
    let labelChildren = label;
    const computedColon = colon === true || contextColon !== false && colon !== false;
    const haveColon = computedColon && !vertical;
    if (haveColon && typeof label === "string" && label.trim() !== "") {
      labelChildren = label.replace(/[:|：]\s*$/, "");
    }
    const computedRequiredMark = requiredMark === true || contextRequiredMark !== false && requiredMark !== false;
    const haveRequired = computedRequiredMark && required;
    const labelCls = mergeCls(!haveColon ? `${prefixCls}-item-no-colon` : "", haveRequired ? `${prefixCls}-item-required` : "");
    return /* @__PURE__ */ React__default.createElement(StyledCol, __spreadProps(__spreadValues({}, mergedLabelCol), {
      className: labelColClassName
    }), /* @__PURE__ */ React__default.createElement(StyledLabel, {
      style: { height: (_a = MAPPING_SIZE) == null ? void 0 : _a[size] },
      htmlFor,
      className: labelCls
    }, /* @__PURE__ */ React__default.createElement(Body, {
      level: 2,
      weight: "medium",
      color: "textTitle"
    }, labelChildren)));
  });
};
const StyledCol = styled(Col)`
  text-align: right;
  &.teko-form-item-label-left {
    text-align: left;
  }
`;
const StyledLabel = styled.label`
  /* height: 40px; */
  display: inline-flex;
  align-items: center;
  &.teko-form-item-required {
    &:before {
      display: inline-block;
      margin-right: 4px;
      color: #ff4d4f;
      font-size: 12px;
      font-family: SimSun, sans-serif;
      line-height: 1;
      content: '*';
    }
  }
  &:after {
    content: ':';
    position: relative;
    top: -0.5px;
    margin: 0 8px 0 2px;
  }
  &.teko-form-item-no-colon {
    margin-right: 8px;
    &:after {
      display: none;
    }
  }
`;
var FormItemLabel$1 = FormItemLabel;

export { FormItemLabel$1 as default };
